<template>
    <div>
        <h1>Zipcode System</h1>
        <el-row :gutter="20">
            <el-col :span="12" class=" first-content">
                <el-card>
                    <el-row>
                        <el-col>
                            <el-radio-group v-model="tableType" @change="selectedAddress">
                                <el-radio-button
                                    v-for="(item, index) in statePage"
                                    :key="index"
                                    :label="item.name"
                                    type="primary"
                                    plain
                                    :span="6"
                                >
                                </el-radio-button>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card shadow="never" style="padding-bottom:10px;">
                    <el-row :gutter="20">
                        <el-col>
                            <ZipcodeSystemTable :buttonMode.sync="selectTableState" />
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
            <el-col :span="12" class="second-content">
                <el-card class="createBar">
                    <el-row >
                        <el-col>
                            <el-radio-group v-model="createType" @change="updateZipcode">
                                <el-radio-button
                                    v-for="(item, index) in zipMode"
                                    :key="index"
                                    :label="item.name"
                                    type="primary"
                                    plain
                                    :span="6"
                                >
                                </el-radio-button>
                            </el-radio-group>
                        </el-col >
                    </el-row>
                    <el-row>
                        <el-col>
                            <ZipcodeSystemCreate :mode.sync ="selectCreateState"/>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import ZipcodeSystemTable from '@/components/Courier/zipCodeSystem/ZipcodeSystemTable'
import ZipcodeSystemCreate from '@/components/Courier/zipCodeSystem/ZipcodeSystemCreate'

export default {
    name: 'SubAddress',
    components: {
        ZipcodeSystemTable,
        ZipcodeSystemCreate
    },
    data () {
        return {
            statePage: [
                { key: 0, name: 'รหัสไปรษณีย์' },
                { key: 1, name: 'จังหวัด' },
                { key: 2, name: 'อำเภอ' },
                { key: 3, name: 'ตำบล' }
            ],
            zipMode: [
                { key: 1, name: 'เพิ่มรหัสไปรษณีย์' },
                { key: 2, name: 'เพิ่มอำเภอ' },
                { key: 3, name: 'เพิ่มตำบล' }
            ],
            tableType: [0, 1, 2, 3],
            createType: [0, 1, 2],
            selectTableState: null,
            selectCreateState: null
        }
    },
    created () {
        this.tableType = 'รหัสไปรษณีย์'
        this.createType = 'เพิ่มรหัสไปรษณีย์'
        this.selectedAddress()
        this.updateZipcode()
    },
    methods: {
        selectedAddress () {
            console.log('path', this.tableType)
            switch (this.tableType) {
            case 'รหัสไปรษณีย์':
                this.selectTableState = this.statePage[0]
                break
            case 'จังหวัด':
                this.selectTableState = this.statePage[1]
                break
            case 'อำเภอ':
                this.selectTableState = this.statePage[2]
                break
            case 'ตำบล':
                this.selectTableState = this.statePage[3]
                break
            }
        },
        updateZipcode (val) {
            switch (this.createType) {
            case 'เพิ่มรหัสไปรษณีย์':
                this.selectCreateState = this.zipMode[0]
                break
            case 'เพิ่มอำเภอ':
                this.selectCreateState = this.zipMode[1]
                break
            case 'เพิ่มตำบล':
                this.selectCreateState = this.zipMode[2]
                break
            }
        }
    }
}
</script>
